import React, { useContext, useEffect, useState } from "react";
import { Offcanvas, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { capitalizeFirstLetter } from "../../utils/Helper";

function SubAdminFilter({ appliedFilters,show, onHide, onApplyFilter,onClear }) {
    const [filters, setFilters] = useState({
        name: appliedFilters?.name || "",
        email: appliedFilters?.email || "",
        role_id: appliedFilters?.role_id || "",
        status: appliedFilters?.status || "",
      });

  const [filterOptions, setFilterOptions] = useState({
    roles: [],
  });
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const navigate = useNavigate();

  useEffect(() => {
    fetchFilterOptions();
  }, []);

  const fetchFilterOptions = async () => {
    try {
      const [roles] = await Promise.all([
        APIServices.get(`/admin/role_list?system_role=0&sort_by=name`, headers),
      ]);

      setFilterOptions({
        roles: roles?.data?.data?.list || [],
      });
    } catch (error) {
      console.error("Error fetching filter data:", error);
    }
  };


  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });
  };

  return (
    <Offcanvas
      className="mom_filter"
      show={show}
      onHide={onHide}
      placement="end"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="font_blue_18 font-600">
          Filter By
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0">
        <Form className="filter_form">
          <div>
            <label className="font_blue_14 font-500 mb-2">
            Name
            </label>
            <Form.Control
                type="text"
                placeholder="Enter Name"
                name="name"
                value={filters.name}
                onChange={handleFilterChange} 
            />
          </div>


          <div>
            <label className="font_blue_14 font-500 mb-2">
            Email
            </label>
            <Form.Control
              name="email"
              placeholder="Enter Email"
              value={filters.email}
              onChange={handleFilterChange}
            >
            </Form.Control>
          </div>

          <div>
            <label className="font_blue_14 font-500 mb-2">
             Role
            </label>
            <Form.Select
              name="role_id"
              value={filters.role_id}
              onChange={handleFilterChange}
            >
              <option value="">Select Role</option>
              {filterOptions?.roles?.map((role) => (
                <option key={role.id} value={role.id}>
                  {capitalizeFirstLetter(role.name)}
                </option>
              ))}
            </Form.Select>
          </div>
          
          <div>
            <label className="font_blue_14 font-500 mb-2">Status</label>
            <Form.Select
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option value="">Select status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Form.Select>
          </div>
        </Form>
        <div className="offcanvas-footer">
          <button className="btn blue_border" onClick={onClear}>
            Clear
          </button>
          <button
            className="btn red_button"
            onClick={() => onApplyFilter(filters)}
          >
            Apply
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default SubAdminFilter;
